import {setFetchingForView} from '@/helpers'

export default {
  setFetchingForView
}



// WEBPACK FOOTER //
// ./src/store/modules/knowledgechecks/mutations.js